/* eslint-disable no-param-reassign */
import { useState, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import * as actions from '~/store/actions';
import api from '~/services';
import { hasOnlyNumber, log } from '~/helpers';

export default function useUserInfo(value = []) {
  const [userInfo, setUserInformation] = useState(value);
  const userInfoMemo = useMemo(() => userInfo, [userInfo]);
  const dispatch = useDispatch();

  const setUserInfo = useCallback(async () => {
    try {
      const usersData = await api.users.get.userInfo();
      setUserInformation(usersData.data);
      if (hasOnlyNumber(usersData.data.outbound_cli)) {
        dispatch(
          actions.addCallerIdCountryCode(
            parsePhoneNumberFromString(
              String(`+${usersData.data.outbound_cli.slice(2)}`)
            )?.countryCallingCode
          )
        );
        localStorage.setItem('userExtension', usersData.data.user_extension);
        dispatch(actions.authSetUserExtension(usersData.data.user_extension));
      }
    } catch (err) {
      log.error('Failed to set user outbound CLI.', err);
    }
  }, [dispatch]);

  return [userInfoMemo, setUserInfo];
}
